import React from 'react';

if (typeof document !== 'undefined' && !document.getElementById('wr-sum-v2-css')) {
  const s = document.createElement('style');
  s.id = 'wr-sum-v2-css';
  s.textContent = `
    /* Mobile-first */
    .wr-sum-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      padding: 16px;
      background: var(--bg, #0a1117);
    }
    .wr-sum-card {
      background: var(--card, #111a2e);
      border: 1px solid var(--border, #1e2d44);
      border-left-width: 4px;
      border-radius: var(--radius-lg, 14px);
      padding: 14px;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
    .wr-sum-card--high     { border-left-color: #E11D48; }
    .wr-sum-card--elevated { border-left-color: #F59E0B; }
    .wr-sum-card--incidents{ border-left-color: #e9a020; }
    .wr-sum-card--active   { border-left-color: #6366F1; }

    .wr-sum-label {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      color: var(--text-3, #8892a5);
    }
    .wr-sum-value {
      font-size: 32px;
      font-weight: 700;
      line-height: 1;
      color: var(--text, #F1F5F9);
      font-family: var(--font-display, 'Fraunces', serif);
    }
    .wr-sum-value--text {
      font-size: 18px;
    }
    .wr-sum-sub {
      font-size: 11px;
      color: var(--text-3, #8892a5);
    }

    @media (min-width: 640px) {
      .wr-sum-grid {
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        padding: 16px 24px;
      }
      .wr-sum-card    { padding: 18px; }
      .wr-sum-label   { font-size: 12px; }
      .wr-sum-value   { font-size: 40px; }
      .wr-sum-value--text { font-size: 22px; }
      .wr-sum-sub     { font-size: 12px; }
    }

    @media (min-width: 1024px) {
      .wr-sum-grid  { gap: 16px; }
      .wr-sum-card  { padding: 24px; }
      .wr-sum-label { font-size: 12px; letter-spacing: 0.6px; }
      .wr-sum-value { font-size: 48px; }
      .wr-sum-value--text { font-size: 28px; }
      .wr-sum-sub   { font-size: 13px; }
    }
  `;
  document.head.appendChild(s);
}

function StatCard({ variant, label, value, sub, isText }) {
  return (
    <div className={`wr-sum-card wr-sum-card--${variant}`}>
      <div className="wr-sum-label">{label}</div>
      <div className={`wr-sum-value${isText ? ' wr-sum-value--text' : ''}`}>
        {value}
      </div>
      {sub && <div className="wr-sum-sub">{sub}</div>}
    </div>
  );
}

export default function SummaryBar({ zones, incidents }) {
  const highZones     = (zones || []).filter(z => z.risk_level === 'high').length;
  const elevatedZones = (zones || []).filter(z => z.risk_level === 'elevated').length;

  const cutoff7d = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const recent   = (incidents || []).filter(i => new Date(i.date || i.published).getTime() > cutoff7d);

  const zoneCounts = {};
  recent.forEach(i => {
    const z = i.zone || i.zone_name || 'Unknown';
    zoneCounts[z] = (zoneCounts[z] || 0) + 1;
  });
  const topEntry = Object.entries(zoneCounts).sort((a, b) => b[1] - a[1])[0];

  return (
    <div className="wr-sum-grid">
      <StatCard
        variant="high"
        label="Active High-Risk Zones"
        value={highZones}
        sub="JWC Listed Areas"
      />
      <StatCard
        variant="elevated"
        label="Elevated Risk Zones"
        value={elevatedZones}
        sub="JWC Listed Areas"
      />
      <StatCard
        variant="incidents"
        label="Incidents (7 days)"
        value={recent.length > 0 ? recent.length : '—'}
        sub="Maritime news sources"
      />
      <StatCard
        variant="active"
        label="Most Active Zone"
        value={topEntry ? topEntry[0] : '—'}
        sub={topEntry ? `${topEntry[1]} incident${topEntry[1] !== 1 ? 's' : ''} · 7 days` : 'No recent data'}
        isText={!!topEntry}
      />
    </div>
  );
}
